import React, {useEffect, useState} from 'react'
import Header from "../layout/header";
import BottomMenu from "../layout/bottomMenu";
import CorporateBuilding from "./FromsAccordingToAccountTypes/CorporateBuilding";
import CorporateTenant from "./FromsAccordingToAccountTypes/CorporateTenant";
import Strategic from "./FromsAccordingToAccountTypes/Strategic"
import Society from "./FromsAccordingToAccountTypes/Society";
import SiteDetails from "./FromsAccordingToAccountTypes/SiteDetails";
import "../Dashboard/Dashboard.css";
import "../Dashboard/Sidebar.js";
import useLatLng from "../../hooks/uselatlng/uselatlng";
import ClientDetails from "./FromsAccordingToAccountTypes/ClientDetails";
import Partner from "./FromsAccordingToAccountTypes/Partner";
import SuccessModal from '../CustomModal/Success'
import FailedModal from "../CustomModal/Failed";
import Loader from "../../Loader/Loader";
import DashboardMenu from "../layout/dashboardMenu";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure()

const AccountAttributes = ({
                               documentUploadUrlPublic,
                               documentUrlDataPublic,
                               dropdownData,
                               dropdownValue = [],
                               locationPinCode,
                               pincodeData,
                               locationCity,
                               locationZone,
                               locationArea,
                               cities = [],
                               zones = [],
                               areas = [],
                               saveAccount,
                               saveDetails = [],
                               accountDetailsById,
                               accountDetailsByIdData = [],
                               match,
                               updateAccount,
                               updateAccountDetails = [],
                               fetchReportee,
                               reportee = [],
                               history,
                               stateAndRegion,
                               stateRegionDetails=[]
                           }) => {

    let validRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
    const [pocDetails, addPOCDetails] = useState([{
        name: '',
        city: '',
        designation: '',
        email: '',
        number: '',
        designation_type_id: ''
    }])
    const [projectTypes, setProjectTypes] = useState([])
    const [inputList, setInputList] = useState([{
        account_type_id: '',
        client_name: '',
        building_name: '',
        developer_name: '',
        lead_source_id: '',
        sale_team_name: '',
        name_of_referrer: '',
        first_contact_date: '',
        occupancy_id: '',
        fmc_name_id: '',
        fmc_name: '',
        strategic_partner_id: '',
        marquee_account: '',
        is_existing_parking_solution: '',
        existing_parking_solution_id: '',
        existing_parking_solution_name: '',
        existing_parking_solution_vendor_name: '',
        is_ev_infra_existing: '',
        existing_ev_infra: '',
        existing_ev_solution_vendor_name: '',
        park_slot: '',
        gates: '',
        electric_vehicles: '',
        city_id: '',
        zone_id: '',
        area_id: '',
        address_1: '',
        address_2: '',
        site_images: [],
        no_of_employees: '',
        no_of_parking_slot_allotted: '',
        no_of_employee_using_electric: '',
        client_type_id: '',
        building_managed: '',
        gate_managed: '',
        parking_slot_managed: '',
        site_type_id: '',
        lead_type: '',
        region: '',
        location_type: '',
        no_of_car_slots: '',
        no_of_bike_slots: '',
        no_of_entered_gate: '',
        no_of_exist_gate: '',
        no_of_parking_floor: '',
        no_of_parking_revenue: '',
        security_agency: '',
        parking_agency: '',
        car_occupancy_rate_id: '',
        bike_occupancy_rate_id: '',
        society_conflict_level: '',
        society_type_id: '',
        alternative_channel_id: '',
        ev_vehicle: '',
        total_maintenance_per_month: '',
        bank_account_name_id: '',
        no_of_ev_vehicles: '',
        branch_name: '',
        no_of_flats: '',
        security_agency_id: '',
        security_agency_name: '',
        enterprise_channel_id: '',
        amenity_id: '',
        no_of_gate_to_be_installed: '',
        no_of_gate_to_be_installed_at_main_gate_society: '',
        no_of_gate_to_be_installed_at_basement: '',
        existing_setup_society_id: '',
        count_of_barriers: '',
        barrier_type_id: '',
        barrier_make_id: '',
        count_of_barriers_make: '',
        age_of_barrier: '',
        amc_of_current_setup: '',
        boom_barrier_image: '',
        reader_image: '',
        count_of_readers: '',
        reader_make_id: '',
        reader_age_of_setup: '',
        enterprise_partner_id: '',
        distribute_channel_id: '',
        inbound_channel_id: '',
        vms_id: '',
        client_city_id: '',
        client_state_id: '',
        client_pincode: '',
        client_lat: '',
        client_long: '',
        client_address_1: '',
        client_address_2: '',
        project_type: '',
        total_parking_slot: '',
        parking_slot_type_id: '',
        pincode: '',
        current_location: '',
        site_image: [],
        parking_visitor_slot:'',
        parking_resident_slot:'',
        state_id:'',
        field_executive:'',
        latitude:'',
        longitude:''
    }]);

    const [isLoading, setIsLoading] = useState(false)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = React.useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)

    const [pincode, setPincode] = useState([]);
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const islatlng = useLatLng();
    const [isAllow, setIsAllow] = useState(false);
    const [corpporateAccountType, setCorporateAccountType] = useState([]);
    const [supplyAccountType, setSupplyAccountType] = useState([]);
    const [apartmentAccountType, setApartmentAccountType] = useState([]);
    const [pocCorporate, setPocCorporate] = useState([])
    const [pocApartment, setPocApartment] = useState([])
    const [isEdit, setIsEdit] = useState(false)
    const [siteImages, setSiteImages] = useState([{url: ''}])
    const [userMessage, setUserMessage] = useState('')
    const [redirectUrl, setRedirectUrl] = useState('')
    const [isView, setIsView] = useState(false)
    const [userId, setUserId] = useState('')
    const [roleId, setRoleId] = useState("")
    const [accountTypes, setAccountTypes] = useState([])

    useEffect(() => {
        let roleId = localStorage.getItem('role_id')
        setRoleId(roleId)
    }, [])

    useEffect(() => {
        (async () => {
            setIsView(false)
            var split = document.URL.split("/");
            if (localStorage.getItem('userId') !== undefined) {
                setUserId(localStorage.getItem('user_id'))
            }

            if (split.includes('view-account')) {
                setIsView(true)
            }
            setIsLoading(true)
            await dropdownData()
            await locationCity()
            await fetchReportee()
            setIsLoading(false)
        })()
    }, [])

    useEffect(() => {
        if (dropdownValue?.corporate_account_type !== undefined) {
            setCorporateAccountType(dropdownValue?.corporate_account_type)
        }

        if (dropdownValue?.supply_account_type !== undefined) {
            setSupplyAccountType(dropdownValue?.supply_account_type)
        }

        if (dropdownValue?.society_type !== undefined) {
            setApartmentAccountType(dropdownValue?.society_type)
        }

        if (dropdownValue?.project_types !== undefined) {
            setProjectTypes(dropdownValue?.project_types)
        }

        if (dropdownValue?.poc_apartment !== undefined) {
            setPocApartment(dropdownValue?.poc_apartment)
        }

        if (dropdownValue?.poc_corporate !== undefined) {
            setPocCorporate(dropdownValue?.poc_corporate)
        }

        if (dropdownValue?.account_project_type !== undefined) {
            setAccountTypes(dropdownValue?.account_project_type)
        }

    }, [dropdownValue])

    const handleInput = (val, index) => {
        const list = [...inputList]
        list[0][index] = val
        setInputList(list)
    }

    const handlePocInput = (val, index, i) => {
        const list = [...pocDetails]
        list[i][index] = val
        addPOCDetails(list)
    }

    const getCityStateByPincode = async (pincode) => {
        if (pincode === '') {
            return false
        }
        await locationPinCode(pincode)
    }

    useEffect(() => {

        setPincode([])
        if (pincodeData && pincodeData.length > 0) {
            setPincode(pincodeData[0])
        }
    }, [pincodeData])

    const handleAddSiteImages = () => {
        let list = [...siteImages]
        setSiteImages([
            ...siteImages,
            {
                url: ''
            }
        ])
    }

    const removeSiteImages = (e, index) => {
        const list = [...siteImages]
        list.splice(index, 1);
        setSiteImages(list);
        e.preventDefault()
    }

    const handleSiteImagesInput = (index, val) => {
        let list = [...siteImages]
        list[index]['url'] = val
        setSiteImages(list)
    }

    const handleAddPOC = () => {
        // const list = [...pocDetails]
        addPOCDetails([
            ...pocDetails,
            {
                name: '',
                city: '',
                designation: '',
                email: '',
                number: '',
                designation_type_id: ''
            }
        ])
    }

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (parseInt(saveDetails?.status) === 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsSuccessModalOpen(true)
            setUserMessage(saveDetails?.message)
            if (match?.params?.lead_id !== undefined) {
                setRedirectUrl('list-account/' + match?.params?.lead_id)
            } else {
                setRedirectUrl('list-account')
            }
        } else if (saveDetails?.status !== undefined && saveDetails?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
            setUserMessage(saveDetails?.message)
        }
    }, [saveDetails])

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (parseInt(updateAccountDetails?.status) === 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsSuccessModalOpen(true)
            setUserMessage(updateAccountDetails?.message)
            if (match?.params?.lead_id !== undefined) {
                setRedirectUrl('list-account/' + match?.params?.lead_id)
            } else {
                setRedirectUrl('list-account')
            }
        } else if (updateAccountDetails?.status !== undefined && updateAccountDetails?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
            setUserMessage(updateAccountDetails?.message)
        }
    }, [updateAccountDetails])

    const handleRemovePOC = (e, index) => {
        const list = [...pocDetails]
        list.splice(index, 1);
        addPOCDetails(list);
        e.preventDefault()
    }

    const [accountType, setAccountType] = useState('')
    const [accountTypeName, setAccountTypeName] = useState("")
    const [projectTypeId, setProjectTypeId] = useState('')

    useEffect(() => {
        if (match?.params?.id !== undefined) {
            (async () => {
                setIsLoading(true)
                await accountDetailsById(match?.params?.id)
                setIsLoading(false)
            })()
        }
    }, [match.params.id])

    useEffect(() => {
        if (accountDetailsByIdData !== [] && accountDetailsByIdData?.account_type_id !== undefined) {
            (async () => {
                await locationPinCode(accountDetailsByIdData?.pincode)
            })()
            setIsEdit(true)
            setProjectTypeId(accountDetailsByIdData?.project_type)
            setAccountType(accountDetailsByIdData?.account_type_id)
            if (accountDetailsByIdData?.poc_details !== [] && accountDetailsByIdData?.poc_details.length > 0) {
                addPOCDetails(accountDetailsByIdData?.poc_details)
            }

            var split = document.URL.split("/");
            if (split.includes('edit-account') && parseInt(accountDetailsByIdData?.stage) === 11) {
                toast.error("You can't update account details now")
                window.location.href = "view-account/" + match?.params?.id
            }
            // if(parseInt(accountDetailsByIdData?.is_draft) === 1){
            //     setIsView(false)
            // }
        }
    }, [accountDetailsByIdData])

    const handleAccountTypeChange = (value) => {
        setAccountType(value)
        if (value === "1") {
            setAccountTypeName('Corporate Building')
        } else if (value === "2") {
            setAccountTypeName('Corporate Tenant')
        } else if (value === "3") {
            setAccountTypeName('Strategic')
        } else if (value === "4") {
            setAccountTypeName('Partner')
        } else if (value === "5") {
            setAccountTypeName('Project')
        } else if (value === "6") {
            setAccountTypeName('Society')
        }
    }

    const handleProjectTypes = (id) => {

        setAccountType('')
        setProjectTypeId(id)
        addPOCDetails([{
            name: '',
            city: '',
            designation: '',
            email: '',
            number: '',
            designation_type_id: ''
        }])
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        let requestParams = inputList[0]
        if (accountType === 4) {
            if (requestParams['client_pincode'] === '') {
                toast.error("Client pincode is required")
                return false
            } else if (requestParams['client_address_1'] === '') {
                toast.error("Client address 1 is required")
                return false
            } else if (requestParams['client_address_1'] === '') {
                toast.error("Client address 2 is required")
                return false
            }
        }

        let isEmailValid = true
        let msg = ''
        pocDetails.map((val, i) => {
            if(val.name !== '' && !val?.email.match(validRegex)){
                msg = "Enter valid email for "+val.name
                isEmailValid = false
            }

            if(val.name !== '' && val?.number.length  < 10 || val?.number.length > 10){
                msg = "Enter valid phone no for "+val.name
                isEmailValid = false
            }
        })

        if(!isEmailValid){
            toast.error(msg)
            return false
        }

        requestParams['poc_details'] = pocDetails
        requestParams['project_type'] = projectTypeId
        requestParams['account_type_id'] = accountType
        requestParams['geographical_state_id'] = pincode?.geo_state_id
        requestParams['geographical_city_id'] = pincode?.geo_city_id
        requestParams['pincode'] = pincode?.pincode
        // requestParams['latitude'] = islatlng?.lat
        // requestParams['longitude'] = islatlng?.lng
        // requestParams['current_lat'] = islatlng?.lat
        // requestParams['current_long'] = islatlng?.lng
        requestParams['client_lat'] = islatlng?.lat
        requestParams['client_long'] = islatlng?.lng
        requestParams['site_image'] = siteImages
        requestParams['is_draft'] = false

        // console.log("requestParamsrequestParams "+JSON.stringify(requestParams))
        if(requestParams['latitude'] == null || requestParams['longitude'] == null || requestParams['client_lat'] == null || requestParams['client_long'] == null){
            toast.error('Please enable your location');
            return false
        }

        if(match?.params?.lead_id !== undefined){
            requestParams['lsq_lead_id'] = match?.params?.lead_id
        }
        // return false
        setIsLoading(true)
        if (isEdit) {
            requestParams['id'] = match?.params.id
            await updateAccount(requestParams)
        } else {
            await saveAccount(requestParams)
        }
        setIsLoading(false)
    }


    const handleDraft = async (e) => {
        e.preventDefault()
        let requestParams = inputList[0]

        if (projectTypeId === '') {
            toast.error("Please select Account type")
            return false
        }

        if (accountType === '') {
            toast.error("Please select Account sub type")
            return false
        } else if (parseInt(projectTypeId) === 1) {
            if (parseInt(accountType) === 1 || parseInt(accountType) === 2) {
                if (requestParams['client_name'] === '') {
                    toast.error('Client name is required')
                    return false
                } else if (requestParams['building_name'] === '') {
                    toast.error('Building name is required')
                    return false
                } else if (requestParams['lead_source_id'] === '') {
                    toast.error('Account source is required')
                    return false
                }
            } else if (parseInt(accountType) === 3) {
                if (requestParams['client_name'] === '') {
                    toast.error('Client name is required')
                    return false
                } else if (requestParams['lead_source_id'] === '') {
                    toast.error('Account source is required')
                    return false
                }
            }
        } else {
            if (requestParams['client_name'] === '') {
                toast.error('Client name is required')
                return false
            } else if (requestParams['lead_source_id'] === '') {
                toast.error('Account source is required')
                return false
            }
        }


        let isEmailValid = true
        let msg = ''
        pocDetails.map((val, i) => {
            if(!val?.email.match(validRegex)){
                msg = "Enter valid email for "+val.name
                isEmailValid = false
            }
        })

        if(!isEmailValid){
            toast.error(msg)
            return false
        }


        requestParams['is_draft'] = true
        requestParams['poc_details'] = pocDetails
        requestParams['project_type'] = projectTypeId
        requestParams['account_type_id'] = accountType
        requestParams['geographical_state_id'] = pincode?.geo_state_id
        requestParams['geographical_city_id'] = pincode?.geo_city_id
        requestParams['pincode'] = pincode?.pincode
        // requestParams['latitude'] = islatlng?.lat
        // requestParams['longitude'] = islatlng?.lng
        requestParams['client_lat'] = mapLocation?.lat
        requestParams['client_long'] = mapLocation?.lng
        requestParams['site_image'] = siteImages

        if(requestParams['client_lat'] == null || requestParams['client_long'] == null){
            toast.error('Please enable your location');
            return false
        }

        if (match?.params?.lead_id !== undefined) {
            requestParams['lsq_lead_id'] = match?.params?.lead_id
        }

        setIsLoading(true)
        if (isEdit) {
            requestParams['id'] = match?.params.id
            await updateAccount(requestParams)
        } else {
            await saveAccount(requestParams)
        }
        setIsLoading(false)
    }

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={userMessage}
                url={redirectUrl}
            />


            <FailedModal
                isOpen={isFailedModalOpen}
                msg={userMessage}
                countToOpenModal={countToOpenModal}
            />
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header 
                            title={'Account'}
                            history={history}
                        />
                        {/*BODY*/}
                        <div>
                        <div className="container-fluid">
                            {/*Heading*/}
                            <div className="hide d-sm-flex align-items-center justify-content-between com-heading">
                                <h1 className="h3 mb-0 text-black-100">Add Account</h1>
                            </div>
                            <form onSubmit={(e) => handleSubmit(e)}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-0 bg-white">
                                            <div className="div-com-header">
                                            </div>
                                            <div className="card-body">
                                                <div className="user">
                                                    <div className="form-group row">
                                                        {/*{isView &&*/}
                                                        {/*    <div className="col-md-6 float-field mt-sel">*/}
                                                        {/*        <select className="form-control form-control-user" onChange={(e) => {}} required >*/}
                                                        {/*            <option value="">Select Assignee</option>*/}
                                                        {/*            {reportee && reportee?.data !== undefined && reportee?.data.map((val) => {*/}
                                                        {/*                return (*/}
                                                        {/*                    <>*/}
                                                        {/*                        <option value={val?.id}>{val.name}</option>*/}
                                                        {/*                    </>*/}
                                                        {/*                )*/}
                                                        {/*            })}*/}
                                                        {/*        </select>*/}
                                                        {/*        <label className="large-label float-lb">*/}
                                                        {/*            Change assignee <i className="bi bi-asterisk astrick-icon"></i>*/}
                                                        {/*        </label>*/}
                                                        {/*    </div>*/}
                                                        {/*}*/}
                                                        <div className="col-sm-12 col-md-6 float-field">

                                                            {accountDetailsByIdData && isEdit ?
                                                                <>
                                                                    <select className="form-control"
                                                                            onChange={(e) => {
                                                                                handleProjectTypes(accountDetailsByIdData?.project_type)
                                                                            }} disabled
                                                                            style={isView ? {backgroundImage: "none"} : {}}>
                                                                        <option
                                                                            value={accountDetailsByIdData?.project_type}>{accountDetailsByIdData?.project_name}</option>
                                                                    </select>

                                                                    <label className="large-label float-lb">
                                                                        Account Type
                                                                    </label>
                                                                </> :
                                                                <>
                                                                    <select className="form-control"
                                                                            onChange={(e) => {
                                                                                handleProjectTypes(e.target.value)
                                                                            }} required>
                                                                        <option value="">Select Account Type</option>
                                                                        {accountTypes !== [] &&
                                                                            accountTypes.map((val) => {
                                                                                return (
                                                                                    <option
                                                                                        value={val?.id}>{val.name}</option>
                                                                                )
                                                                        })}
                                                                        {/*<option value="1">Corporate</option>*/}
                                                                        {/*<option value="2">Society</option>*/}
                                                                        {/*<option value="3">Mall</option>*/}
                                                                        {/*<option value="5">Hotel</option>*/}
                                                                        {/*<option value="6">Public Parking</option>*/}
                                                                        {/*<option value="7">Banquet</option>*/}
                                                                        {/*<option value="8">Hospital</option>*/}
                                                                        {/*<option value="9">Super Tag</option>*/}
                                                                        {/*<option value="4">Other</option>*/}
                                                                    </select>

                                                                    <label className="large-label float-lb">
                                                                        Account Type
                                                                    </label>
                                                                </>
                                                            }
                                                        </div>
                                                        {/*{parseInt(projectTypeId) === 2 && apartmentAccountType.length > 1 &&*/}
                                                        {/*    <div className="col-sm-12 col-md-6 float-field mtk-2">*/}

                                                        {/*        <select className="form-control"*/}
                                                        {/*                onChange={(e) => {*/}
                                                        {/*                    handleAccountTypeChange(e.target.value)*/}
                                                        {/*                }} required>*/}
                                                        {/*            <option value="">Select Account Type</option>*/}
                                                        {/*            {parseInt(projectTypeId) === 2 &&*/}
                                                        {/*                apartmentAccountType !== [] &&*/}
                                                        {/*                apartmentAccountType.map((val) => {*/}
                                                        {/*                    return (*/}
                                                        {/*                        <option*/}
                                                        {/*                            value={val?.id}>{val.name}</option>*/}
                                                        {/*                    )*/}
                                                        {/*                })*/}
                                                        {/*            }*/}

                                                        {/*        </select>*/}

                                                        {/*        <label className="large-label float-lb">*/}
                                                        {/*            Account Sub Type*/}
                                                        {/*        </label>*/}
                                                        {/*    </div>*/}
                                                        {/*}*/}
                                                        <div className="col-sm-12 col-md-6 float-field mtk-2">

                                                            {accountDetailsByIdData && isView?
                                                                <>
                                                                    <select className="form-control"
                                                                            onChange={(e) => {
                                                                                handleAccountTypeChange(accountDetailsByIdData?.account_type_id)
                                                                            }} disabled
                                                                            style={isView ? {backgroundImage: "none"} : {}}>
                                                                        <option
                                                                            value={accountDetailsByIdData?.account_type_id}>
                                                                            {parseInt(accountDetailsByIdData?.project_type) === 2 ? accountDetailsByIdData?.society_type_name : accountDetailsByIdData?.account_type}
                                                                        </option>
                                                                    </select>

                                                                    <label className="large-label float-lb">
                                                                        Account Sub-Type
                                                                    </label>
                                                                </>
                                                                :
                                                                <>
                                                                    <select className="form-control"
                                                                            onChange={(e) => {
                                                                                handleAccountTypeChange(e.target.value)
                                                                            }} required>
                                                                        <option value="">Select Account Sub-Type
                                                                        </option>
                                                                        {parseInt(projectTypeId) === 1 &&
                                                                            corpporateAccountType !== [] &&
                                                                            corpporateAccountType.map((val) => {
                                                                                return (
                                                                                    <>
                                                                                        {parseInt(accountDetailsByIdData?.account_type_id) === val?.id ?
                                                                                            <option
                                                                                                value={val?.id} selected>{val.name}</option>
                                                                                            :
                                                                                            <option
                                                                                                value={val?.id}>{val.name}</option>
                                                                                        }
                                                                                    </>
                                                                                )
                                                                            })
                                                                        }
                                                                        {projectTypeId !== '' && parseInt(projectTypeId) !== 1 && parseInt(projectTypeId) !== 2 &&
                                                                            supplyAccountType !== [] &&
                                                                            supplyAccountType.map((val) => {
                                                                                return (
                                                                                    <>
                                                                                        {parseInt(accountDetailsByIdData?.account_type_id) === val?.id ?
                                                                                            <option
                                                                                                value={val?.id} selected>{val.name}</option>
                                                                                            :
                                                                                            <option
                                                                                                value={val?.id}>{val.name}</option>
                                                                                        }
                                                                                    </>
                                                                                )
                                                                            })
                                                                        }
                                                                        {parseInt(projectTypeId) === 2 &&
                                                                            apartmentAccountType !== [] &&
                                                                            dropdownValue?.society_type.map((val) => {
                                                                                return (
                                                                                    <>
                                                                                        {parseInt(accountDetailsByIdData?.account_type_id) === val?.id ?
                                                                                            <option
                                                                                                value={val?.id} selected>{val.name}</option>
                                                                                            :
                                                                                            <option
                                                                                                value={val?.id}>{val.name}</option>
                                                                                        }
                                                                                    </>
                                                                                )
                                                                            })
                                                                        }
                                                                    </select>

                                                                    <label className="large-label float-lb">
                                                                        Account Sub-Type
                                                                    </label>
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {parseInt(projectTypeId) === 2 && accountType !== '' &&
                                        <>
                                            {/*<div className="col-md-12">*/}
                                            {/*    <div*/}
                                            {/*        className="d-sm-flex align-items-center justify-content-between com-sub-heading">*/}
                                            {/*        <h1 className="h3 mb-0 text-black-100">Society</h1>*/}
                                            {/*    </div>*/}
                                            {/*    <div className="mb-0 bg-white">*/}
                                            {/*        <div className="card-body">*/}
                                            {/*            <div className="user">*/}
                                            {/*                <div className="form-group row">*/}
                                            {/*                  */}
                                            {/*                </div>*/}
                                            {/*            </div>*/}
                                            {/*        </div>*/}
                                            {/*    </div>*/}
                                            {/*</div>*/}
                                            <Society
                                                documentUploadUrlPublic={documentUploadUrlPublic}
                                                documentUrlDataPublic={documentUrlDataPublic}
                                                dropdownValue={dropdownValue}
                                                getCityStateByPincode={getCityStateByPincode}
                                                pincodeData={pincode}
                                                handleInput={handleInput}
                                                locationCity={cities}
                                                locationZone={locationZone}
                                                locationArea={locationArea}
                                                zones={zones}
                                                areas={areas}
                                                inputList={inputList}
                                                accountDetailsByIdData={accountDetailsByIdData}
                                                isEdit={isEdit}
                                                isView={isView}
                                                stateAndRegion={stateAndRegion}
                                                stateRegionDetails={stateRegionDetails}
                                            />
                                        </>
                                    }
                                    {parseInt(projectTypeId) !== 2 && accountType !== '' &&
                                        <>
                                            {/*<div className="col-md-12">*/}
                                            {/*    <div*/}
                                            {/*        className="d-sm-flex align-items-center justify-content-between com-sub-heading">*/}
                                            {/*        <h1 className="h3 mb-0 text-black-100">{accountTypeName}</h1>*/}
                                            {/*    </div>*/}
                                            {/*    <div className="mb-0 bg-white">*/}
                                            {/*        <div className="card-body">*/}
                                            {/*            <div className="user">*/}

                                            {/*            </div>*/}
                                            {/*        </div>*/}
                                            {/*    </div>*/}
                                            {/*</div>*/}
                                            <div className="form-group" style={{'width':'100%'}}>
                                                {parseInt(accountType) === 1 &&
                                                    <CorporateBuilding
                                                        handleInput={handleInput}
                                                        documentUploadUrlPublic={documentUploadUrlPublic}
                                                        documentUrlDataPublic={documentUrlDataPublic}
                                                        dropdownValue={dropdownValue}
                                                        getCityStateByPincode={getCityStateByPincode}
                                                        pincodeData={pincode}
                                                        lat={mapLocation?.lat}
                                                        long={mapLocation?.lng}
                                                        locationCity={cities}
                                                        locationZone={locationZone}
                                                        locationArea={locationArea}
                                                        zones={zones}
                                                        areas={areas}
                                                        siteImages={siteImages}
                                                        handleAddSiteImages={handleAddSiteImages}
                                                        removeSiteImages={removeSiteImages}
                                                        handleSiteImagesInput={handleSiteImagesInput}
                                                        accountDetailsByIdData={accountDetailsByIdData}
                                                        inputList={inputList}
                                                        isEdit={isEdit}
                                                        setSiteImages={setSiteImages}
                                                        isView={isView}
                                                    />
                                                }
                                                {parseInt(accountType) === 2 &&
                                                    <CorporateTenant
                                                        documentUploadUrlPublic={documentUploadUrlPublic}
                                                        documentUrlDataPublic={documentUrlDataPublic}
                                                        dropdownValue={dropdownValue}
                                                        getCityStateByPincode={getCityStateByPincode}
                                                        pincodeData={pincode}
                                                        lat={mapLocation?.lat}
                                                        long={mapLocation?.lng}
                                                        handleInput={handleInput}
                                                        locationCity={cities}
                                                        locationZone={locationZone}
                                                        locationArea={locationArea}
                                                        zones={zones}
                                                        areas={areas}
                                                        siteImages={siteImages}
                                                        handleAddSiteImages={handleAddSiteImages}
                                                        removeSiteImages={removeSiteImages}
                                                        handleSiteImagesInput={handleSiteImagesInput}
                                                        accountDetailsByIdData={accountDetailsByIdData}
                                                        inputList={inputList}
                                                        isEdit={isEdit}
                                                        setSiteImages={setSiteImages}
                                                        isView={isView}
                                                    />
                                                }
                                                {parseInt(accountType) === 3 &&
                                                    <Strategic
                                                        documentUploadUrlPublic={documentUploadUrlPublic}
                                                        documentUrlDataPublic={documentUrlDataPublic}
                                                        dropdownValue={dropdownValue}
                                                        getCityStateByPincode={getCityStateByPincode}
                                                        pincodeData={pincode}
                                                        lat={mapLocation?.lat}
                                                        long={mapLocation?.lng}
                                                        handleInput={handleInput}
                                                        locationCity={cities}
                                                        locationZone={locationZone}
                                                        locationArea={locationArea}
                                                        zones={zones}
                                                        areas={areas}
                                                        siteImages={siteImages}
                                                        handleAddSiteImages={handleAddSiteImages}
                                                        removeSiteImages={removeSiteImages}
                                                        handleSiteImagesInput={handleSiteImagesInput}
                                                        accountDetailsByIdData={accountDetailsByIdData}
                                                        inputList={inputList}
                                                        isEdit={isEdit}
                                                        setSiteImages={setSiteImages}
                                                        isView={isView}
                                                    />
                                                }

                                                {/*{parseInt(projectTypeId) === 2 &&*/}
                                                {/*    <Society*/}
                                                {/*        documentUploadUrlPublic={documentUploadUrlPublic}*/}
                                                {/*        documentUrlDataPublic={documentUrlDataPublic}*/}
                                                {/*        dropdownValue={dropdownValue}*/}
                                                {/*        getCityStateByPincode={getCityStateByPincode}*/}
                                                {/*        pincodeData={pincode}*/}
                                                {/*        lat={mapLocation?.lat}*/}
                                                {/*        long={mapLocation?.lng}*/}
                                                {/*        handleInput={handleInput}*/}
                                                {/*        locationCity={cities}*/}
                                                {/*        locationZone={locationZone}*/}
                                                {/*        locationArea={locationArea}*/}
                                                {/*        zones={zones}*/}
                                                {/*        areas={areas}*/}
                                                {/*    />*/}
                                                {/*}*/}
                                                {(parseInt(accountType) === 4 || parseInt(accountType) === 5) &&
                                                    <Partner
                                                        documentUploadUrlPublic={documentUploadUrlPublic}
                                                        documentUrlDataPublic={documentUrlDataPublic}
                                                        dropdownValue={dropdownValue}
                                                        getCityStateByPincode={getCityStateByPincode}
                                                        pincodeData={pincode}
                                                        lat={mapLocation?.lat}
                                                        long={mapLocation?.lng}
                                                        handleInput={handleInput}
                                                        locationCity={cities}
                                                        locationZone={locationZone}
                                                        locationArea={locationArea}
                                                        zones={zones}
                                                        areas={areas}
                                                        accountDetailsByIdData={accountDetailsByIdData}
                                                        inputList={inputList}
                                                        isEdit={isEdit}
                                                        isView={isView}
                                                    />
                                                }
                                            </div>

                                            {(parseInt(accountType) === 4 || parseInt(accountType) === 5) &&
                                                <>
                                                    <div className="col-md-12">
                                                        <div
                                                            className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                            <h1 className="h3 mb-0 text-black-100">Client Details</h1>
                                                        </div>
                                                        <div className="mb-0 bg-white">
                                                            <div className="card-body">
                                                                <div className="user">
                                                                    <div className="form-group row">
                                                                        <ClientDetails
                                                                            lat={mapLocation?.lat}
                                                                            long={mapLocation?.lng}
                                                                            handleInput={handleInput}
                                                                            locationPinCode={locationPinCode}
                                                                            accountDetailsByIdData={accountDetailsByIdData}
                                                                            inputList={inputList}
                                                                            isView={isView}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }

                                            {(parseInt(accountType) === 4 || parseInt(accountType) === 5) &&
                                                <>
                                                    <div className="col-md-12">
                                                        <div
                                                            className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                            <h1 className="h3 mb-0 text-black-100">Site Details</h1>
                                                        </div>
                                                        <div className="mb-0 bg-white">
                                                            <div className="card-body">
                                                                <div className="user">
                                                                    <div className="form-group row">
                                                                        <SiteDetails
                                                                            documentUploadUrlPublic={documentUploadUrlPublic}
                                                                            documentUrlDataPublic={documentUrlDataPublic}
                                                                            dropdownValue={dropdownValue}
                                                                            lat={mapLocation?.lat}
                                                                            long={mapLocation?.lng}
                                                                            handleInput={handleInput}
                                                                            locationCity={cities}
                                                                            locationZone={locationZone}
                                                                            locationArea={locationArea}
                                                                            zones={zones}
                                                                            areas={areas}
                                                                            locationPinCode={locationPinCode}
                                                                            siteImages={siteImages}
                                                                            handleAddSiteImages={handleAddSiteImages}
                                                                            removeSiteImages={removeSiteImages}
                                                                            handleSiteImagesInput={handleSiteImagesInput}
                                                                            accountDetailsByIdData={accountDetailsByIdData}
                                                                            inputList={inputList}
                                                                            isEdit={isEdit}
                                                                            setSiteImages={setSiteImages}
                                                                            isView={isView}
                                                                            stateAndRegion={stateAndRegion}
                                                                            stateRegionDetails={stateRegionDetails}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </>
                                    }
                                    <div className="col-md-12">
                                        <div
                                            className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                            <h1 className="h3 mb-0 text-black-100">POC Details</h1>
                                        </div>
                                        <div className="mb-4 bg-white"> {/*card*/}
                                            <div className="hide card-header bg-lightGreen-active">
                                                POC Details
                                            </div>
                                            <div className="card-body">
                                                <div className="user">
                                                    <div className="form-group row">
                                                        {pocDetails.map((val, i) => {
                                                            return (
                                                                <>
                                                                    {/*<div className="col-sm-12" id={i + 1}>*/}
                                                                    <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                        <input type="text"
                                                                               className="form-control form-control-user"
                                                                               placeholder=" "
                                                                               onChange={(e) => {
                                                                                   handlePocInput(e.target.value, 'name', i)
                                                                               }}
                                                                               // required
                                                                               value={val?.name}
                                                                               disabled={isView}
                                                                        />
                                                                        <label
                                                                            className="large-label float-lb">
                                                                            Name
                                                                            {isEdit &&
                                                                                <i
                                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                            }

                                                                        </label>
                                                                    </div>
                                                                    {/*<div className="col-sm-6 col-md-3 mt-1 float-field">*/}

                                                                    {/*    <input type="text"*/}
                                                                    {/*           className="form-control form-control-user"*/}
                                                                    {/*           placeholder=" "*/}
                                                                    {/*           onChange={(e) => {*/}
                                                                    {/*               handlePocInput(e.target.value, 'city', i)*/}
                                                                    {/*           }}*/}
                                                                    {/*           required*/}
                                                                    {/*           value={val?.city}*/}
                                                                    {/*           disabled={isView}*/}
                                                                    {/*    />*/}
                                                                    {/*    <label*/}
                                                                    {/*        className="large-label float-lb">*/}
                                                                    {/*        City <i*/}
                                                                    {/*        className="bi bi-asterisk astrick-icon"></i>*/}
                                                                    {/*    </label>*/}
                                                                    {/*</div>*/}
                                                                    {(parseInt(projectTypeId) === 1 || parseInt(projectTypeId) === 2) &&
                                                                        <div className="col-sm-6 col-md-3 mt-05-mb-04 float-field d-mtk-1">
                                                                            <select className="form-control "
                                                                                    onChange={(e) => {
                                                                                        handlePocInput(e.target.value, 'designation_type_id', i)
                                                                                    }}  disabled={isView}
                                                                                    style={isView ? {backgroundImage: "none"} : {}}>
                                                                                <option value="">Select
                                                                                    Designation
                                                                                </option>
                                                                                {parseInt(projectTypeId) === 1 &&
                                                                                    pocCorporate !== [] &&
                                                                                    pocCorporate.map((val) => {
                                                                                        return (
                                                                                            // <option value={val?.id}>{val.name}</option>
                                                                                            <>
                                                                                                {(accountDetailsByIdData !== [] && accountDetailsByIdData?.poc_details !== undefined && accountDetailsByIdData?.poc_details[i]?.designation_type_id === val?.id) ?
                                                                                                    <>
                                                                                                        return (
                                                                                                        <option
                                                                                                            value={val?.id}
                                                                                                            selected>{val.name}</option>
                                                                                                        )
                                                                                                    </> :
                                                                                                    <option
                                                                                                        value={val?.id}>{val.name}</option>
                                                                                                }
                                                                                            </>
                                                                                        )
                                                                                    })
                                                                                }
                                                                                {parseInt(projectTypeId) === 2 &&
                                                                                    pocApartment !== [] &&
                                                                                    pocApartment.map((val) => {
                                                                                        return (
                                                                                            <>
                                                                                                {/*<option value={val?.id}>{val.name}</option>*/}
                                                                                                {(accountDetailsByIdData?.poc_details !== undefined &&
                                                                                                    parseInt(accountDetailsByIdData?.poc_details[i]?.designation_type_id) === val?.id) ?
                                                                                                    <>
                                                                                                        return (
                                                                                                        <option
                                                                                                            value={val?.id}
                                                                                                            selected>{val.name}</option>
                                                                                                        )
                                                                                                    </> :
                                                                                                    <option
                                                                                                        value={val?.id}>{val.name}</option>
                                                                                                }
                                                                                            </>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </select>
                                                                            <label
                                                                                className="large-label float-lb">
                                                                                Designation

                                                                                {isEdit &&
                                                                                    <i
                                                                                        className="bi bi-asterisk astrick-icon"></i>
                                                                                }
                                                                            </label>
                                                                        </div>
                                                                    }
                                                                    {/* <div className="col-sm-6 col-md-3 mt-1 float-field"> */}
                                                                        {(parseInt(projectTypeId) !== 1 && parseInt(projectTypeId) !== 2) &&
                                                                            <>
                                                                            <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                                <input type="text"
                                                                                       className="form-control form-control-user"
                                                                                       placeholder=" "
                                                                                       onChange={(e) => {
                                                                                           handlePocInput(e.target.value, 'designation', i)
                                                                                       }}
                                                                                       // required
                                                                                       value={val?.designation}
                                                                                       disabled={isView}
                                                                                />
                                                                                <label
                                                                                    className="large-label float-lb">
                                                                                    Designation Name
                                                                                    {isEdit &&
                                                                                        <i
                                                                                            className="bi bi-asterisk astrick-icon"></i>
                                                                                    }
                                                                                </label>
                                                                                </div>
                                                                            </>
                                                                        }

                                                                        {parseInt(val?.designation_type_id) === 9 &&
                                                                            <>
                                                                            <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                                <input type="text"
                                                                                       className="form-control form-control-user"
                                                                                       placeholder=" "
                                                                                       onChange={(e) => {
                                                                                           handlePocInput(e.target.value, 'designation', i)
                                                                                       }}
                                                                                       required
                                                                                       value={val?.designation}
                                                                                       disabled={isView}
                                                                                />
                                                                                <label
                                                                                    className="large-label float-lb">
                                                                                    Designation Name
                                                                                    {isEdit &&
                                                                                        <i
                                                                                            className="bi bi-asterisk astrick-icon"></i>
                                                                                    }
                                                                                </label>
                                                                                </div>
                                                                            </>
                                                                        }
                                                                    {/* </div> */}
                                                                    <div className="col-sm-6 col-md-3 float-field d-mtk-1">
                                                                        <input type="email"
                                                                               className="form-control form-control-user"
                                                                               placeholder=" "
                                                                               onChange={(e) => {
                                                                                   handlePocInput(e.target.value, 'email', i)
                                                                               }}
                                                                               // required
                                                                               value={val?.email}
                                                                               disabled={isView}
                                                                        />
                                                                        <label
                                                                            className="large-label float-lb">
                                                                            Email Id
                                                                            {isEdit &&
                                                                                <i
                                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                            }
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-sm-6 col-md-3 mt-1 float-field">

                                                                        <input type="number"
                                                                               className="form-control form-control-user"
                                                                               placeholder=" "
                                                                               onChange={(e) => {
                                                                                   handlePocInput(e.target.value, 'number', i)
                                                                               }}
                                                                               // required
                                                                               value={val?.number}
                                                                               disabled={isView}
                                                                               pattern={"[1-9]{1}[0-9]{9}"}
                                                                        />
                                                                        <label
                                                                            className="large-label float-lb">
                                                                            Mobile Number
                                                                            {isEdit &&
                                                                                <i
                                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                            }
                                                                        </label>
                                                                    </div>
                                                                    {!isView &&
                                                                        <div className="btn-box mb-4"
                                                                             style={{"width": "100%"}}>
                                                                            {pocDetails.length !== 1 &&
                                                                                <>
                                                                                    <button
                                                                                        onClick={(e) => handleRemovePOC(e, i)}
                                                                                        className="btn btn-sm btn-danger ml-3 btn-ar">Remove
                                                                                    </button>
                                                                                </>
                                                                            }
                                                                            {pocDetails.length - 1 === i &&
                                                                                <button
                                                                                    className="btn btn-sm btn-primary ml-3 btn-ar"
                                                                                    onClick={() => handleAddPOC()}>Add
                                                                                </button>}
                                                                        </div>
                                                                    }
                                                                    {/*</div>*/}
                                                                </>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    {!isView ?
                                        <>
                                            <div className="col-sm-12 mb-4">
                                                <button className="btn btn-primary btn-user btn-block submit-btn">
                                                    {isEdit ? "Update" : 'Submit'}
                                                </button>
                                            </div>
                                            {/* Draft button hidden — save/update flow unchanged via handleSubmit */}
                                            {/*{!isEdit || (accountDetailsByIdData?.is_draft !== undefined && parseInt(accountDetailsByIdData?.is_draft) === 1) ?
                                                <>
                                                    <div className="col-sm-6">
                                                        <a href="#" className="draft-float"
                                                           onClick={(e) => handleDraft(e)}>
                                                            <p className="my-float">Draft</p>
                                                        </a>
                                                    </div>
                                                </>
                                                : ''
                                            }*/}
                                        </> :
                                        <>
                                            {userId !== '' && parseInt(userId) === parseInt(accountDetailsByIdData?.assigned_to) && accountDetailsByIdData?.account_type_id !== undefined
                                                && parseInt(accountDetailsByIdData?.stage) !== 11 &&
                                                (parseInt(roleId) === 5 || parseInt(roleId) === 6 || parseInt(roleId) === 7 || parseInt(roleId) === 16 || parseInt(roleId) === 4) &&
                                                <div className="col-sm-6">
                                                    <a href={match?.params?.lead_id !== undefined ? `/edit-account/${match?.params?.id}/${match?.params?.lead_id}` : `edit-account/${match?.params?.id}`}
                                                       className="draft-float">
                                                        <p className="my-float">Edit</p>
                                                    </a>
                                                </div>
                                            }
                                        </>
                                    }
                                </div>
                            </form>
                        </div>
                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default AccountAttributes